import { I18n } from "@/i18n/I18n";
import { Row, Col, Card, Placeholder } from "react-bootstrap";

export function CardPlaceholder() {
  return (
    <Row xs={1} md={2} lg={4} className="g-4" aria-label={I18n.get('loading')}>
      {[1, 2, 3, 4].map((index) => (
        <Col key={index}>
          <Card className="h-100">
            <div className="p-3 bg-light">
              <div className="bg-white rounded d-flex align-items-center justify-content-center">
                <Placeholder animation="wave" style={{ width: '100%', height: '200px' }}>
                  <Placeholder xs={12} bg="secondary" style={{ height: '200px' }} />
                </Placeholder>
              </div>
            </div>
            <Card.Body className="d-flex flex-column bg-light">
              <Card.Title>
                <Placeholder animation="wave">
                  <Placeholder xs={8} bg="secondary" />
                </Placeholder>
              </Card.Title>
              <Card.Text>
                <Placeholder animation="wave">
                  <Placeholder xs={12} bg="secondary" className="mb-2" />
                  <Placeholder xs={10} bg="secondary" />
                </Placeholder>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}